<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Bolsa Família"
            description="Cobertura das condicionalidades na vigência atual"
            url="/dashboard"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-9531"
            :enableBadgeModalInformacao="
              Number($store.state.permissoesRaw?.bolsa_familia_ajuda || 0) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.bolsa_familia_ajuda || 0
            "
            keyAjudaModalInformacao="bolsa_familia_ajuda"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <div
                class="ribbon"
                v-if="item.featured !== undefined && item.featured == true"
              >
                <span>BETA</span>
              </div>

              <span
                v-if="$store.getters.getQuantidadeAjuda(item.key) > 0"
                class="item-badge"
              >
                {{ $store.getters.getQuantidadeAjuda(item.key) }}
              </span>

              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import GestantesIcon from '@/components/icons/BolsaFamilia/GestantesIcon.vue'
import CriancasMulheresIcon from '@/components/icons/BolsaFamilia/CriancasMulheresIcon.vue'

export default {
  name: 'BolsaFamilia',
  metaInfo: {
    title: 'Bolsa Família',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    GestantesIcon,
    CriancasMulheresIcon,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.bolsa_familia
      ) {
        const dataClone = [...this.$store.state.permissoes.bolsa_familia]
        return dataClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style></style>
